module.exports = {
      id: "icon-pause-usage",
      viewBox: "0 0 17.726 22.137",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#icon-pause",
      toString: function () {
        return this.url;
      }
    }